import React from 'react'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Constant from '../../../Constant'
import Loader from '../../../common/Loader'
import Button from '../../../common/CustomComponents/Button'
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

class ProductImageList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    isPaydoStore: false,
    disableVideoAdd: false,
    openUploadModal: false,
    uploadType: null,
    videoPreview: 'set',
    galleryLargeImage: '',
    galleryLargeImages: [], // For multiple images
    imagePreview: '',
    imagePreviews: [], // For multiple image previews
    isSaving: false,
    disableDownloadAllImages: false,
  }

  deleteProducts = (id) => {
    var productId = this.props.match.params.productId
    var data = {
      img_id: id,
      productId: productId,
    }
    axios
      .delete(Constant.getAPI() + '/store/delete-store-product-img', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        data,
      })
      .then(() => {
        Swal.fire({
          title: 'Product Image Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.dashbord()
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  componentDidMount() {
    this.dashbord()
  }

  dashbord = async () => {
    var that = this
    this.setState({ isloading: true })
    var productId = this.props.match.params.productId

    await axios
      .get(Constant.getAPI() + `/store/list-product-images/${productId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const isPaydoStore = res.data?.data?.[0]?.store?.store?.is_paydo_store
          const data = res.data?.data
          this.setState({ isloading: false })

          // Check if any video already exists
          const videoFormats = /\.(mp4|avi|mov|wmv|flv)$/i
          const containsVideo = data.some((item) => videoFormats.test(item.image_path))

          that.setState({
            Products_data: data,
            isPaydoStore,
            disableVideoAdd: containsVideo,
          })
        }
      })
      .catch((err) => {
        this.setState({ isloading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChangeImage = (e) => {
    const files = Array.from(e.target.files || [])

    // Validate all files are images
    const invalidFiles = files.filter((file) => file?.type?.startsWith('video/'))
    if (invalidFiles.length > 0) {
      Swal.fire('Invalid image file', 'Please select only image files', 'error')
      this.setState({
        galleryLargeImages: [],
        imagePreviews: [],
      })
      if (this.fileInputRef) this.fileInputRef.value = ''
      return
    }

    // Create previews for all selected images
    const previews = files.map((file) => URL.createObjectURL(file))

    this.setState({
      galleryLargeImages: files,
      galleryLargeImage: files[0] || '', // Keep for backward compatibility
      imagePreviews: previews,
      imagePreview: previews[0] || '', // Keep for backward compatibility
      videoPreview: null,
    })
  }

  handleChangeVideo = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    if (e.target.files[0]?.type?.startsWith('image/')) {
      Swal.fire('Invalid video file', '', 'error')
      this.setState({ galleryLargeImage: null, galleryLargeImages: [], imagePreviews: [] })
      return
    } else {
      this.setState({
        videoPreview: URL.createObjectURL(e.target.files?.[0]),
        imagePreview: null,
        imagePreviews: [],
        galleryLargeImages: [],
      })
    }
  }

  handleSave = () => {
    const formData = new FormData()
    var productId = this.props.match.params.productId
    formData.append('product_id', productId)

    // If multiple images are selected, append all of them
    if (this.state.uploadType === 'image' && this.state.galleryLargeImages.length > 0) {
      this.state.galleryLargeImages.forEach((file) => {
        formData.append('image_path', file)
      })
    } else {
      // Single file upload (for video or backward compatibility)
      formData.append('image_path', this.state.galleryLargeImage)
    }

    this.setState({ isSaving: true })

    axios
      .post(Constant.getAPI() + '/store/add-store-product-image', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        // Clean up object URLs to prevent memory leaks
        this.state.imagePreviews.forEach((preview) => {
          if (preview) URL.revokeObjectURL(preview)
        })
        if (this.state.videoPreview && this.state.videoPreview !== 'set') {
          URL.revokeObjectURL(this.state.videoPreview)
        }

        // Store upload type and count from response before resetting state
        const uploadType = this.state.uploadType
        const responseData = res.data?.data
        const itemCount = Array.isArray(responseData) ? responseData.length : 1

        this.setState({
          isSaving: false,
          openUploadModal: false,
          galleryLargeImage: '',
          galleryLargeImages: [],
          imagePreview: '',
          imagePreviews: [],
          videoPreview: 'set',
        })
        if (res.status) {
          // Determine the success message based on upload type
          let successMessage = ''
          if (uploadType === 'video') {
            successMessage = 'Video Added Successfully!'
          } else {
            successMessage = `${itemCount} ${itemCount > 1 ? 'Images' : 'Image'} Added Successfully!`
          }

          Swal.fire({
            title: successMessage,
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          if (this.fileInputRef) this.fileInputRef.value = ''
        }
        this.dashbord()
      })
      .catch((err) => {
        // Clean up object URLs on error
        this.state.imagePreviews.forEach((preview) => {
          if (preview) URL.revokeObjectURL(preview)
        })
        if (this.state.videoPreview && this.state.videoPreview !== 'set') {
          URL.revokeObjectURL(this.state.videoPreview)
        }

        this.setState({ isSaving: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            showConfirmButton: false,
            timer: 2500,
          })
        }
      })
  }

  downloadAllMedia = async (selectedRows) => {
    this.setState({ disableDownloadAllImages: true })

    const { Products_data } = this.state
    const selectedIndices = selectedRows.map((rowIndex) => rowIndex)
    const selectedItems = selectedIndices.map((i) => Products_data[i])

    const mediaUrls = selectedItems
      .map((item) => item.image_path)
      .filter((url) => typeof url === 'string' && url.length > 0)

    if (mediaUrls.length === 0) {
      Swal.fire({
        title: 'No media selected for download.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      })
      this.setState({ disableDownloadAllImages: false })
      return
    }

    const folderName = 'Product_media'
    const zip = new JSZip()
    const folder = zip.folder(folderName)

    const errors = []

    try {
      await Promise.all(
        mediaUrls.map(async (relativePath, idx) => {
          const fullUrl = relativePath.startsWith('http') ? relativePath : Constant.getImage() + relativePath

          // Better file extension detection
          const ext = /\.(mp4|mov|avi|wmv|flv)$/i.test(relativePath) ? '.mp4' : '.jpg'
          const fileName = `Product_media_${idx + 1}${ext}`

          try {
            const resp = await fetch(fullUrl)
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
            const blob = await resp.blob()
            folder.file(fileName, blob)
          } catch (err) {
            console.error(`Failed to fetch ${fullUrl}:`, err)
            errors.push(fullUrl)
          }
        })
      )

      const content = await zip.generateAsync({ type: 'blob' })
      const zipFileName = `Product_media_${Date.now()}.zip`
      saveAs(content, zipFileName)

      if (errors.length) {
        Swal.fire({
          title: `Downloaded ${mediaUrls.length - errors.length} files, but failed to fetch ${errors.length} file(s)`,
          icon: 'warning',
          confirmButtonText: 'Ok',
        })
      }
    } catch (zipErr) {
      console.error('Error creating zip:', zipErr)
      Swal.fire({
        title: 'An error occurred while generating the ZIP file.',
        icon: 'error',
        confirmButtonText: 'Ok',
      })
    } finally {
      this.setState({ disableDownloadAllImages: false })
    }
  }

  render() {
    const columns = [
      {
        name: 'image_path',
        label: 'Product Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (image_path) => {
            return (
              <div>
                {image_path !== null && image_path !== undefined ? (
                  <div>
                    {image_path?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="150"
                        height="100"
                        controls
                      >
                        <source
                          src={
                            image_path !== undefined && image_path !== null
                              ? Constant.getImage() + image_path
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={image_path !== undefined && image_path !== null ? image_path : './assets/images/icon.png'}
                        className="img-fluid"
                        style={{ height: 50 }}
                        alt="tbl"
                        onError={(event) => {
                          event.currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={image_path !== undefined && image_path !== null ? image_path : './assets/images/icon.png'}
                    className="img-fluid"
                    style={{ height: 50 }}
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          display: !this.state.isPaydoStore,
          customBodyRender: (id) => {
            return (
              <div>
                <span
                  onClick={this.deleteProducts.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      filter: false,
      selectableRows: true,
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      customToolbarSelect: (selectedRows) => {
        return (
          <Button
            startIcon={
              this.state.disableDownloadAllImages ? (
                <i className="icofont icofont-spin icofont-refresh"></i>
              ) : (
                <i className="icofont icofont-download-alt"></i>
              )
            }
            disabled={this.state.disableDownloadAllImages}
            onClick={() => {
              const selectedIndices = selectedRows.data.map((row) => row.index)
              this.downloadAllMedia(selectedIndices)
            }}
          >
            {this.state.disableDownloadAllImages ? 'Downloading...' : 'Download All Image/Video'}
          </Button>
        )
      },
    }

    return (
      <div className="pcoded-inner-content">
        {this.state?.isloading && (
          <Loader
            open={this.state?.isloading}
            fullPage={true}
          />
        )}
        <Dialog
          open={this.state.openUploadModal}
          fullWidth
          maxWidth="lg"
          onBackdropClick={() => {
            // Clean up object URLs
            this.state.imagePreviews.forEach((preview) => {
              if (preview) URL.revokeObjectURL(preview)
            })
            if (this.state.videoPreview && this.state.videoPreview !== 'set') {
              URL.revokeObjectURL(this.state.videoPreview)
            }

            this.setState({
              openUploadModal: false,
              galleryLargeImage: '',
              galleryLargeImages: [],
              imagePreview: '',
              imagePreviews: [],
              videoPreview: 'set',
            })
          }}
        >
          <DialogTitle>{this.state.uploadType === 'video' ? 'Add Video' : 'Add Image(s)'}</DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-12 m-b-10">
                {this.state.videoPreview !== 'set' ? (
                  <div>
                    {this.state.videoPreview !== null ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={this.state.videoPreview ?? './assets/images/icon.png'}
                          type="video/mp4"
                        />
                      </video>
                    ) : this.state.imagePreviews.length > 0 ? (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        {this.state.imagePreviews.map((preview, index) => (
                          <img
                            key={index}
                            width="150px"
                            height="150px"
                            src={preview}
                            alt={`Preview ${index + 1}`}
                            style={{ objectFit: 'cover', border: '1px solid #ddd', borderRadius: '4px' }}
                          />
                        ))}
                      </div>
                    ) : (
                      <img
                        width="150px"
                        src={this.state.imagePreview ?? './assets/images/icon.png'}
                        alt="img"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    width="150px"
                    src={'./assets/images/no_image.png'}
                    alt="img"
                    onError={({ currentTarget }) => {
                      currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
              <div className="col-3">{this.state.uploadType === 'video' ? 'Video(MP4)' : 'Image(s)'}</div>
              <div className="col-5">
                <div className="form-group">
                  {this.state.uploadType === 'image' ? (
                    <input
                      ref={(ref) => (this.fileInputRef = ref)}
                      type="file"
                      id="img"
                      name="galleryLargeImage"
                      accept="image/*"
                      multiple
                      className="w-100"
                      onChange={this.handleChangeImage}
                    />
                  ) : (
                    <input
                      ref={(ref) => (this.fileInputRef = ref)}
                      type="file"
                      id="img"
                      name="galleryLargeImage"
                      accept=".mp4"
                      className="w-100"
                      onChange={this.handleChangeVideo}
                    />
                  )}
                </div>
                {this.state.uploadType === 'image' && this.state.galleryLargeImages.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">
                      {this.state.galleryLargeImages.length} image{this.state.galleryLargeImages.length > 1 ? 's' : ''}{' '}
                      selected
                    </small>
                  </div>
                )}
              </div>
              <div className="col-4">
                <div className="row">
                  <div className="text-right col-6 offset-6">
                    <Button
                      disabled={
                        this.state.isSaving ||
                        (this.state.uploadType === 'image'
                          ? this.state.galleryLargeImages.length === 0
                          : !this.state.galleryLargeImage)
                      }
                      startIcon={<i className="ti-save"></i>}
                      onClick={this.handleSave}
                    >
                      {this.state.isSaving ? 'Saving...!' : 'Save'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-12">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Product Image List</h4>
                    </div>
                  </div>
                  {!this.state.isPaydoStore && (
                    <>
                      <Button
                        onClick={() =>
                          this.setState({
                            openUploadModal: true,
                            uploadType: 'image',
                            galleryLargeImage: '',
                            galleryLargeImages: [],
                            imagePreview: '',
                            imagePreviews: [],
                            videoPreview: 'set',
                          })
                        }
                        className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger ml-2"
                      >
                        <i className="icofont icofont-plus m-r-5"></i>
                        Add Image
                      </Button>
                      <Button
                        onClick={() =>
                          this.setState({
                            openUploadModal: true,
                            uploadType: 'video',
                            galleryLargeImage: '',
                            galleryLargeImages: [],
                            imagePreview: '',
                            imagePreviews: [],
                            videoPreview: 'set',
                          })
                        }
                        className={`btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger ${this.state.disableVideoAdd ? 'disabled-button' : ''}`}
                        disabled={this.state.disableVideoAdd}
                      >
                        <i className="icofont icofont-plus m-r-5"></i>
                        Add Video
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      className="table-responsive"
                      data={this.state.Products_data}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductImageList
